<div class="row" *ngIf="!loading">
  <div class="col-lg-7">
    <div class="overview-section">
      <div class="row publisher-scores hidden-md-down" *ngIf="hasPublisherScores">
        <div class="col-lg-12">
          <h3 class="sub-title">
            Publisher Scores
          </h3>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.final?.score">
          <div class="label">Final Score</div>
          <div class="value big-number" enAnonLock>{{data?.ranking?.final?.score}}({{data?.ranking?.final?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.popularity?.score">
          <div class="label">Popularity Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.popularity?.score}}({{data?.ranking?.popularity?.grade}})</div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.ivt?.score">
          <div class="label">IVT Score</div>
          <div class="value big-number" enAnonLock>{{data?.ranking?.ivt?.score}}({{data?.ranking?.ivt?.grade}})</div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.brandSafety?.score">
          <div class="label">Brand Safety Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.brandSafety?.score}}({{data?.ranking?.brandSafety?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.adsTxt?.score">
          <div class="label">App-ads.txt Score</div>
          <div class="value big-number" enAnonLock>{{data?.ranking?.adsTxt?.score}}({{data?.ranking?.adsTxt?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.viewability?.score">
          <div class="label">Viewability Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.viewability?.score}}({{data?.ranking?.viewability?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.permissions?.score && os === 'android'">
          <div class="label">Permission Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.permissions?.score}}({{data?.ranking?.permissions?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.adDensity?.score">
          <div class="label">Ad Density</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.adDensity?.score}}({{data?.ranking?.adDensity?.grade}})</div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.dauMau?.score">
          <div class="label">DAU / MAU</div>
          <div class="value big-number" enAnonLock>{{data?.ranking?.dauMau?.score}}({{data?.ranking?.dauMau?.grade}})
          </div>
        </div>
      </div>
      <div class="row risk-devices" *ngIf="!isFreemium">
        <div class="col-xl-6 risk-device" *ngFor="let deviceType of deviceTypes; let j = index;">
          <ng-container
            *ngIf="reputation[deviceType.name]?.length > 0 && !(reputation[deviceType.name].length === 1 && reputation[deviceType.name][0].pixalateGrade === 'N/A')">
            <h3 class="sub-title text-capitalize mt-4">
              {{deviceType?.name}}
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                [attr.title]="deviceType?.tooltip" style="cursor: pointer;">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h3>
            <div class="row risk-ratings" *ngFor="let region of reputation[deviceType.name]; let i = index;">
              <div class="col-lg-4 pr-0">
                <div class="text-container">
                  <div class="text-item">
                    {{region.region === 'NA' ? 'North America':region.region}}
                  </div>
                </div>
              </div>
              <div class="col">
                <risk-heat-bar [risk]='region.pixalateGrade' [tooltip]='region.pixalateGradeReasonCodeHtml'
                  cssClass='tooltip-pixalate-grade'></risk-heat-bar>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="risk-totals-cont pl-0">
        <div class="row risk-totals">
          <div class="col-lg-4 risk-total-item">
            <div class="divider" *ngIf="hasPublisherScores || hasReputation"></div>
            <h3 class="sub-title">
              IVT
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                data-animation="false" title="The overall estimated percentage of Invalid Traffic (IVT) associated with advertising transactions for the
                   app.  All IVT calculations are derived from standardized definitions of invalid traffic maintained by
                   the Media Rating Council, Inc. (MRC), Interactive Advertising Bureau (IAB), and Trustworthy
                   Accountability Group (TAG).">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h3>
            <div class="big-number">
              <ng-container *ngIf="!isFreemium">
                <a class="btn btn-link p-0 big-number mr-2" (click)="goToSection('#app-ivt')">
                  {{data?.appOverview?.givtSivtRate | perc:'1.2-2'}}
                </a>
                <risk-heat-meter *ngIf="data?.appOverview?.nonGivtSivtViewabilityRating !== 'N/A'"
                  [risk]='data?.appOverview?.givtSivtRateRating'></risk-heat-meter>
              </ng-container>
              <ng-container *ngIf="isFreemium">
                <ng-container *ngIf="!isFollowing">
                  <div class="freemium-lock">
                    <i class="fa fa-lock"></i>
                  </div>
                </ng-container>
                <ng-container *ngIf="isFollowing">
                  <a class="btn btn-link p-0 big-number mr-2" (click)="goToSection('#app-ivt')">
                    {{data?.appOverview?.givtSivtRate | perc:'1.2-2'}}
                  </a>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-4 risk-total-item">
            <div class="divider" *ngIf="hasPublisherScores || hasReputation"></div>
            <h3 class="sub-title">
              Viewability
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                data-animation="false" title="The average viewability for all display ad impressions in the app">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h3>
            <div class="big-number" enAnonLock>
              <a class="btn btn-link p-0 big-number mr-2" (click)="goToSection('#app-viewability')">
                {{data?.appOverview.nonGivtSivtViewability | perc:'1.2-2'}}
              </a>
              <risk-heat-meter *ngIf="data?.appOverview?.nonGivtSivtViewabilityRating !== 'N/A' && !isFreemium"
                [risk]='data?.appOverview?.nonGivtSivtViewabilityRating'></risk-heat-meter>
            </div>
          </div>
          <div class="col-lg-4 risk-total-item">
            <div class="divider" *ngIf="hasPublisherScores || hasReputation"></div>
            <h3 class="sub-title">
              Brand Safety Risk
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                data-animation="false" title="The overall risk to advertiser Brand Safety from the app">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h3>
            <div class="d-flex brand-safety">
              <div class="label">
                <a class="btn btn-link p-0" (click)="goToSection('#brand-safety-risk-description')">Description</a>
              </div>
              <risk-heat-meter [risk]='data?.appOverview?.appDescriptionBrandSafetyRating' enAnonLock></risk-heat-meter>
            </div>
            <div class="d-flex brand-safety">
              <div class="label">
                <a class="btn btn-link p-0" (click)="goToSection('#brand-safety-risk-content')">Content</a>
              </div>
              <risk-heat-meter [risk]='data?.appOverview?.appContentBrandSafetyRating' enAnonLock></risk-heat-meter>
            </div>
          </div>
        </div>
      </div>
      <app-follow-unlock label="Invalid Traffic" (followClick)="follow()" *ngIf="!isFollowing && isFreemium">
      </app-follow-unlock>
    </div>
  </div>
  <div class="col-lg-5 info-column">
    <div class='info-section'>
      <h5 class='info-title'>
        <span>Pixalate Advisories</span>
        <info-tooltip title="Pixalate's unique listing of key advisories for a particular app based on risk factors
             (e.g., app-ads.txt, app permissions, privacy terms, etc.)."></info-tooltip>
      </h5>
      <div class='info-list-2'>
        <!-- todo: click go to section #app-sov -->
        <info-list-item label='App-ads.txt' [lock]='isFreemium' (labelInteract)='goToSection("#app-sov")'
          [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "appOverview.hasAdsTxt" }'
          [value]='data?.appOverview?.hasAdsTxt | yesno:"capitalize"'
          valueIcon='/assets/images/icon-indicator-{{data?.appOverview?.hasAdsTxt | yesno}}-2.svg'>
        </info-list-item>

        <info-list-item label='Exists in App Store' [lock]='isFreemium'>
          <ng-container #value>
            <img src="/assets/images/icon-indicator-{{data?.appOverview?.isExistInAppStore | yesno}}-2.svg"
              alt="Info Icon" />
            <span>
              {{data?.appOverview?.isExistInAppStore | yesno:"capitalize"}}
              <span
                *ngIf="!data?.appOverview?.isExistInAppStore && data?.appOverview?.appRemovedDate && data?.appOverview?.appRemovedDate !== 'N/A'">
                - Removed as of {{data?.appOverview?.appRemovedDate | date}}
              </span>
            </span>
          </ng-container>
        </info-list-item>

        <info-list-item label='Dangerous Permissions' [lock]='isFreemium'
          (labelInteract)='goToSection("#app-permission-risk")' [show]='dangerousPermissionsCount > 0'
          valueIcon="/assets/images/icon-indicator-no-2.svg"
          value='Yes, {{ dangerousPermissionsCount }} dangerous {{ dangerousPermissionsCount | i18nPlural:{ "=1": "permission", "other": "permissions" } }}'>
        </info-list-item>

        <info-list-item label='Blocklisted' [lock]='isFreemium && !isFollowing'
          valueIcon="/assets/images/icon-indicator-{{data?.appOverview?.isAppBlacklisted | yesno:'rev'}}-2.svg"
          value='{{data?.appOverview?.isAppBlacklisted | yesno:"capitalize"}}'>
        </info-list-item>

        <info-list-item label='WHOIS Info Hidden' [lock]='isFreemium'
          valueIcon="/assets/images/icon-indicator-{{data?.publisherOverview?.isPrivateDomain | yesno: 'rev'}}-2.svg"
          value='{{data?.publisherOverview?.isPrivateDomain | yesno:"capitalize"}}'>
        </info-list-item>

        <info-list-item label='Terms and Conditions Detected' [lock]='isFreemium'
          [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "publisherOverview.hasTermsOfServiceLink" }'
          valueIcon="/assets/images/icon-indicator-{{data?.publisherOverview?.hasTermsOfServiceLink | yesno}}-2.svg"
          value='{{data?.publisherOverview?.hasTermsOfServiceLink | yesno:"capitalize"}}'>
        </info-list-item>

        <info-list-item label='Privacy Policy Detected' [lock]='isFreemium' [suggestionConfig]='{
              type: "app",
              id: data?.appOverview?.appId,
              metricId: "publisherOverview.hasPrivacyLink"
            }' valueIcon="/assets/images/icon-indicator-{{data?.publisherOverview?.hasPrivacyLink | yesno}}-2.svg"
          value='{{data?.publisherOverview?.hasPrivacyLink | yesno:"capitalize"}}'>
        </info-list-item>

        <info-list-item label='IVT Permission Risk' [lock]='isFreemium'>
          <risk-heat-meter #value [risk]='data?.permissions?.overallIvtPermissionRisk'></risk-heat-meter>
        </info-list-item>

        <info-list-item label='COPPA Violation Risk'
          [lock]='isFreemium || !_userService.appCoppaPermissionsRiskEnabled()'>
          <risk-heat-meter #value [risk]='data?.coppaPermissions?.coppaRisk'></risk-heat-meter>
        </info-list-item>
      </div>
    </div>
  </div>
</div>